import { render, staticRenderFns } from "./ClassStar.vue?vue&type=template&id=0e36cc46&"
import script from "./ClassStar.vue?vue&type=script&lang=ts&"
export * from "./ClassStar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports